var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-uppercase",attrs:{"color":_vm.stateBackgroundColor,"text-color":_vm.stateTextColor,"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.$t(`events.state.${_vm.state.toLowerCase()}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }